import React, { useState, Component, useEffect, useRef } from 'react';
import '../../src/Hero2.css';
import { Loader } from 'semantic-ui-react';
import { Mensaje } from './mensajes';
import 'animate.css';
import Fade from 'react-reveal/Fade';
import Reveal from 'react-reveal/Reveal';
import Slide from 'react-reveal/Slide';
import Roll from 'react-reveal/Roll';
import Jello from 'react-reveal/Jello';
import makeCarousel from 'react-reveal/makeCarousel';
import styled, { css } from 'styled-components';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import { Dimmer } from 'semantic-ui-react';
import Feedback from 'react-bootstrap/Feedback';
import '../../src/Hero2.css';







function Contactos() {



    const [mostrar, setMostrar] = useState(false);
    const [mostrar1, setMostrar1] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [activate, setActivate] = useState(false);
    const [values, setValues] = useState({
        txtNombre: '',
        txtEmail: ''
    });
    const slider = useRef()



    const abrirModal = () => {
        setMostrar(true);
    }

    const cerrarModal = () => {
        setMostrar(false);
    }

    const enviarCorreo = () => {

        setActivate(true);



        let endpoint = "http://3.141.30.169:5000/send-email";

        axios.post(endpoint, {

            email: 'tvalentin@gmail.com',
            name: values.txtEmail,
            passwd: '',
            message: values.txtNombre

        }).then(function (response) {

            if (response.status == 200) {

                setTitulo("enviado con exito!");
                setMsg('pronto recibirar respuestas');
                setMostrar1(true);

            } else if (response.status == 204) {
                setTitulo("notificación");
                setMsg("correo no encontrado");
                setMostrar1(true);


            }


        }).catch(function (error) {
            setTitulo("notificación");
            setMsg("Error interno de Conexión.");
            setMostrar1(true);

        }).then(function () {
            setActivate(false);
        });

    }

    const onChange = (event) => {

        setValues({ ...values, [event.target.name]: event.target.value });

    };


    const handleCloseMensa = () => {

        setMostrar1(false);

    }

    const [validated, setValidated] = useState(false);

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            enviarCorreo();
        }

        setValidated(true);
    };

    console.log(values)

    return (


        <div className='col-md-12 container-fluid' style={{ padding: 0, margin: 0 }}>
            <div className='contenedor-contactos'>
                <img className='img-fluid' src='imagenes/compu1.jpg' style={{ width: '100%', height: '100%' }} />
                <div className='hover-contactos'></div>

                <div className='content-contactos contenedor-fluid'>

                    <h3>Contactanos</h3>

                </div>

            </div>
            <div className='col-md-12 row mx-auto' style={{ padding: '6%' }}  >

                <div className='col-md-5 formCon '>
                    <img className='img-fluid' src='imagenes/compu1.jpg' style={{ width: '100%', height: '100%' }} />
                    <div className='container-fluid contenedor-formulario'  >
                    </div>
                    <div className='form-contact'>
                        <h1>¿Listo para empezar?</h1><br />
                        <p>Su dirección de correo electrónico no será publicada. Los campos obligatorios están marcados *</p>

                        <form validated={validated} onSubmit={handleSubmit} style={{ padding: '5%' }}>
                            <div className='text-left'>
                                <label htmlFor="exampleInputEmail1" className="form-label text-left">Nombre</label>
                                <input type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                            </div>
                            <div className='text-left'>
                                <label htmlFor="exampleInputEmail1" className="form-label text-left">Correo Electronico</label>
                                <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" required defaulfValue={values.txtEmail} onChange={onChange} />
                            </div>
                            <div className='text-left'>
                                <label htmlFor="exampleFormControlTextarea1" className="form-label text-left">Mensaje</label>
                                <textarea className="form-control" id="exampleFormControlTextarea1" rows={3} required defaulfValue={values.txtNombre} onChange={onChange} />

                            </div>
                            <button className='btn btn-light' style={{ marginTop: '2%', }} type='submit'>Enviar</button>
                        </form>


                    </div>
                </div>

                <div className='row col-md-5 mx-auto formCon2' style={{ padding: '5% 0' }}>


                    <div className='row col-md-12 contenedor-direccion' >
                        <div className='col-md-4 row' style={{ margin: 0, padding: 0 }}>
                            <i class="fa-solid fa-location-dot iconoDirc"></i>

                        </div>
                        <div className='col-md-8 contenido-info' style={{ margin: 0, padding: 0 }}>
                            <h3>Dirección:</h3>
                            <p>Calle 30 entre Av 33 y 34 C.C Orión, piso 1 local 8 Acarigua Edo. Portuguesa</p>
                        </div>
                    </div>

                    <div className='row col-md-12 contenedor-direccion' >
                        <div className='col-md-4 row' style={{ margin: 0, padding: 0 }}>
                            <i class="fa-solid fa-envelope iconoDirc"></i>

                        </div>

                        <div className='col-md-8 contenido-info' style={{ margin: 0, padding: 0 }}>
                            <h3>Correo Electrónico:</h3>
                            <p>sygrecaoficial@gmail.com</p>
                        </div>
                    </div>

                    <div className='row col-md-12 contenedor-direccion' >
                        <div className='col-md-4 row' style={{ margin: 0, padding: 0 }}>
                            <i class="fa-solid fa-phone iconoDirc"></i>

                        </div>
                        <div className='col-md-8 contenido-info' style={{ margin: 0, padding: 0 }}>
                            <h3>Teléfono:</h3>
                            <p>+58 416-4532801  / +58 414-5176923 / 0255478525</p>
                       
                            
                        </div>
                    </div>
                </div>

            </div>
        </div>





    )

} export default Contactos;



// WEBPACK FOOTER //
// ./src/components/contactanos.js